import React from 'react';
import PropTypes from 'prop-types';
import { AutocompleteInput, useGetList } from 'react-admin';

const convertItemToLabel = (record) => {
  return `${record?.family || ''} - ${record?.name || ''}`;
};

const CatalogItemAutocompleteInput = ({
  helperText,
  reference,
  source,
  validate,
  family,
  ...props
}) => {
  const { loading, data } = useGetList(reference, {
    filter: {},
  });

  const keys = Object.keys(data);

  const choices = keys
    .map((key) => {
      return data[key];
    })
    .sort((a, b) => {
      const labelA = convertItemToLabel(a);
      const labelB = convertItemToLabel(b);

      return labelA.localeCompare(labelB);
    });

  return (
    <AutocompleteInput
      source={source}
      choices={choices}
      loading={loading}
      validate={validate}
      optionText={(record) => {
        return `${record?.family || ''} - ${record?.name || ''}`;
      }}
      emptyText="ra.action.clear_input_value"
      allowEmpty
      matchSuggestion={(filterValue, choice) => {
        const label = convertItemToLabel(choice);
        return (
          label.toLowerCase().includes(filterValue.toLowerCase()) &&
          (family ? choice.family === family : true)
        );
      }}
    />
  );
};

CatalogItemAutocompleteInput.propTypes = {
  helperText: PropTypes.bool,
  reference: PropTypes.string,
  source: PropTypes.string,
  family: PropTypes.string,
  validate: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
};

CatalogItemAutocompleteInput.defaultProps = {
  helperText: undefined,
  reference: 'item',
  source: 'catalog_item_id',
  family: undefined,
  validate: [],
};

export default CatalogItemAutocompleteInput;
